import React from "react";
import Header from "./Header";

function Dashboard() {
  return (
    <>
      {/* <!-- Main Content --> */}
      <main className="main-content" id="mainContent">
        <Header heading="Dashboard" />
        {/* <!-- Dashboard Stats --> */}
        {/* <div className="dashboard-grid">
          <div className="stat-card primary">
            <div className="stat-header">
              <div className="stat-title">Total Revenue</div>
              <div className="stat-icon primary">
                <i className="fas fa-dollar-sign"></i>
              </div>
            </div>
            <div className="stat-value">$24,680</div>
            <div className="stat-change positive">
              <i className="fas fa-arrow-up"></i>
              <span>12.5% from last month</span>
            </div>
          </div>

          <div className="stat-card secondary">
            <div className="stat-header">
              <div className="stat-title">New Customers</div>
              <div className="stat-icon secondary">
                <i className="fas fa-users"></i>
              </div>
            </div>
            <div className="stat-value">1,482</div>
            <div className="stat-change positive">
              <i className="fas fa-arrow-up"></i>
              <span>8.2% from last month</span>
            </div>
          </div>

          <div className="stat-card success">
            <div className="stat-header">
              <div className="stat-title">Total Orders</div>
              <div className="stat-icon success">
                <i className="fas fa-shopping-bag"></i>
              </div>
            </div>
            <div className="stat-value">3,594</div>
            <div className="stat-change positive">
              <i className="fas fa-arrow-up"></i>
              <span>5.7% from last month</span>
            </div>
          </div>

          <div className="stat-card warning">
            <div className="stat-header">
              <div className="stat-title">Conversion Rate</div>
              <div className="stat-icon warning">
                <i className="fas fa-chart-pie"></i>
              </div>
            </div>
            <div className="stat-value">3.6%</div>
            <div className="stat-change negative">
              <i className="fas fa-arrow-down"></i>
              <span>1.2% from last month</span>
            </div>
          </div>
        </div> */}

        {/* <!-- Charts --> */}
        {/* <div className="chart-container">
          <div className="chart-header">
            <div className="chart-title">Revenue Overview</div>
            <div className="chart-actions">
              <button className="chart-action" data-period="day">
                Day
              </button>
            </div>
          </div>
        </div> */}
      </main>
    </>
  );
}

export default Dashboard;
